import React from 'react';
import { MapPinIcon, ClockIcon, PhoneIcon, MailIcon } from 'lucide-react';
import ContactForm from './ContactForm';
const CompanyInfo = () => {
  return <section id="company" className="py-16 bg-blue-50" data-id="element-53">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-54">
        <div className="text-center mb-16" data-id="element-55">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-56">会社概要</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-57">
            2025年創業。プロフェッショナルな清掃スタッフサービス
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-58">
          <div data-id="element-59">
            <div className="bg-white p-8 rounded-lg shadow-sm mb-8" data-id="element-60">
              <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-61">会社情報</h3>
              <div className="space-y-4" data-id="element-62">
                <p className="text-gray-700" data-id="element-63">
                  日本清掃センターは、全国の主要都市で訓練された清掃のプロフェッショナルと企業をつなぎます。ホテル、民泊施設、オフィススペースに特化したスタッフ派遣サービスを提供しています。
                </p>
                <p className="text-gray-700" data-id="element-64">
                  2025年の設立以来、専門的な研修、信頼性の高いサービス、透明性のある運営を通じて、ホスピタリティと職場環境における清掃の基準を高めることを使命としています。
                </p>
                <div className="pt-4 border-t border-gray-200" data-id="element-65">
                  <h4 className="font-medium text-gray-900 mb-2" data-id="element-66">企業情報</h4>
                  <ul className="space-y-2" data-id="element-67">
                    <li className="flex items-start" data-id="element-68">
                      <span className="font-medium text-gray-700 w-32" data-id="element-69">
                        会社名:
                      </span>
                      <span className="text-gray-700" data-id="element-70">日本清掃センター</span>
                    </li>
                    <li className="flex items-start" data-id="element-71">
                      <span className="font-medium text-gray-700 w-32" data-id="element-72">
                        設立:
                      </span>
                      <span className="text-gray-700" data-id="element-73">2025年</span>
                    </li>
                    <li className="flex items-start" data-id="element-74">
                      <span className="font-medium text-gray-700 w-32" data-id="element-75">
                        サービス提供地域:
                      </span>
                      <span className="text-gray-700" data-id="element-76">
                        東京、大阪、京都、福岡、名古屋、札幌
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-77">
              <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-78">
                連絡先情報
              </h3>
              <div className="space-y-4" data-id="element-79">
                <div className="flex items-start" data-id="element-80">
                  <div className="bg-blue-100 rounded-full p-2 mr-4 mt-1" data-id="element-81">
                    <MapPinIcon className="h-5 w-5 text-blue-600" data-id="element-82" />
                  </div>
                  <div data-id="element-83">
                    <h4 className="font-medium text-gray-900" data-id="element-84">本社所在地</h4>
                    <p className="text-gray-700" data-id="element-85">
                      東京都世田谷区用賀4丁目34-12
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-86">
                  <div className="bg-blue-100 rounded-full p-2 mr-4 mt-1" data-id="element-87">
                    <ClockIcon className="h-5 w-5 text-blue-600" data-id="element-88" />
                  </div>
                  <div data-id="element-89">
                    <h4 className="font-medium text-gray-900" data-id="element-90">営業時間</h4>
                    <p className="text-gray-700" data-id="element-91">
                      月曜日～土曜日：10:00 - 18:00
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-92">
                  <div className="bg-blue-100 rounded-full p-2 mr-4 mt-1" data-id="element-93">
                    <PhoneIcon className="h-5 w-5 text-blue-600" data-id="element-94" />
                  </div>
                  <div data-id="element-95">
                    <h4 className="font-medium text-gray-900" data-id="element-96">電話番号</h4>
                    <p className="text-gray-700" data-id="element-97">080-7886-2747</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-98">
                  <div className="bg-blue-100 rounded-full p-2 mr-4 mt-1" data-id="element-99">
                    <MailIcon className="h-5 w-5 text-blue-600" data-id="element-100" />
                  </div>
                  <div data-id="element-101">
                    <h4 className="font-medium text-gray-900" data-id="element-102">
                      メールアドレス
                    </h4>
                    <p className="text-gray-700" data-id="element-103">
                      info@japancleaningcenter.com
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="contact" data-id="element-104">
            <ContactForm data-id="element-105" />
          </div>
        </div>
      </div>
    </section>;
};
export default CompanyInfo;